export default __webpack_public_path__ + "static/media/BottomOfConstipation.619b5d04.pdf";